// 1. 외부 패키지
import { useRecoilValue } from "recoil";


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import get_basic_detail_selector from "../../selector/get-basic-detail-selector";
import { getQuery } from "../../shared/function";
import MobileGNB from "../layout/mobile-gnb";


// 4. 타입


const BasicMobileGnb = () => {

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { detail } = data;

	return (
		<MobileGNB title={detail.title} />
	);
};

export default BasicMobileGnb